/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/_baseProperty.js
// module id = 130
// module chunks = 35783957827783 107818501498521 231608221292675